import { useCreatePurchaseStore } from "../../../stores/createPurchaseStore";

/** Exports common helper states and methods for Package checkout */
export const getCreatePurchasePackageFields = () => {
    const { purchase, activeItemIndex, isVariableDemographicsPackage, isAllProductDetailsUpdated } =
        useCreatePurchaseStore.getState();

    const showNextButton =
        isVariableDemographicsPackage() && !isAllProductDetailsUpdated && activeItemIndex !== purchase.items.length - 1;

    return { showNextButton };
};
